import { Component, forwardRef, OnInit, Optional } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { RechtSucheRechteidComponent } from './recht-suche-rechteid/recht-suche-rechteid.component';
import { RechtSucheErweitertComponent } from './recht-suche-erweitert/recht-suche-erweitert.component';
import { RechtSucheEreidComponent } from './recht-suche-ereid/recht-suche-ereid.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-recht-suche',
  templateUrl: './recht-suche.component.html',
  styleUrls: ['./recht-suche.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RechtSucheComponent), multi: true }],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    RechtSucheRechteidComponent,
    RechtSucheErweitertComponent,
    RechtSucheEreidComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class RechtSucheComponent implements OnInit {
  searchMode: SearchMode;

  tabErweitertActive: boolean;

  constructor(
    private stateService: SearchStateService,
    @Optional() private metaDirective?: MetaDirective
  ) {}

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || SearchMode.searchStandard;
  }

  saveTabSettings(event: boolean) {
    this.tabErweitertActive = event;
  }
}
